import HTTP from "./HTTP";

import {URL_SERVICE} from '../constants'


export const login = (email, password)=>{
    return HTTP.post(`${URL_SERVICE}/auth/login`,{email, password});
}